<template>
  <!-- <div class="app-content content">
    <div class="content-wrapper">
      <div class="content-header row"></div>
      <div class="content-body">
        <section class="flexbox-container">
          <router-view />
          <div class="col-12 d-flex align-items-center justify-content-center">
            <div class="col-md-4 col-10 box-shadow-2 p-0">
              <div class="card border-grey border-lighten-3 m-0">
                <div class="card-header border-0">
                  <div class="card-title text-center">
                    <div class="p-1"><img src="" alt="logo" /></div>
                  </div>
                  <h6
                    class="
                      card-subtitle
                      line-on-side
                      text-muted text-center
                      font-small-3
                      mx-2
                    "
                  >
                    <span>Recuperação de senha</span>
                  </h6>
                  <router-link :to="{ name: 'login.index' }"
                    >Voltar</router-link
                  >

                  <div class="alert bg-danger alert-dismissable"></div>
                </div>
                <div class="card-content">
                  <div class="card-body pt-0">
                    <form class="form-horizontal" action="" method="post">
                      <fieldset class="form-group floating-label-form-group">
                        <label for="user-name">Email</label>
                        <input
                          type="text"
                          name="email"
                          class="form-control"
                          placeholder="Email"
                          value=""
                        />

                        <span class="danger"> </span>
                      </fieldset>
                      <button
                        type="submit"
                        class="btn btn-outline-primary btn-block"
                      >
                        <i class="ft-unlock"></i> Enviar
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div> -->
  <div class="h-window-100">
    <div class="container">
      <img src="../../public/images/app/newlogo.png" alt="" />
      <div class="login-container">
        <h4>Recuperação de Senha</h4>
        <!-- <span>A maneira mais simples e eficiente de você fazer a gestão logística.</span> -->
        <p v-if="errors_array.length">
          <span v-for="error in errors_array" style="color: red"
            >{{ "- " + error.erro }}<br
          /></span>
        </p>
        <div class="login-card">
          <label>Email</label>
          <input
            v-model="form.email"
            name="email"
            @keyup.enter="onLogin"
            type="email"
          />
          <button @click="recoveryPassword()" :disabled="isDisabled">
            Enviar
          </button>
          <span
            ><router-link :to="{ name: 'login.index' }"
              >Voltar</router-link
            ></span
          >
          <b-spinner
            v-if="loading"
            style="margin: 15px auto 0 auto; color: #ff7810"
            label="Spinning"
          ></b-spinner>
        </div>
      </div>
    </div>
    <footer />
  </div>
</template>
<script>
import {apiVersion} from "@/main";
import { resolveApiBase } from "@/shared/utils/resolveApiBase";

export default {
  data() {
    return {
      errors_array: [],
      isDisabled: false,
      loading: false,
      form: new Form({ email: "" }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    console.log(`Working on '${process.env.VUE_APP_NOME_APP}' mode`);
  },
  methods: {
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    recoveryPassword() {
      this.loading = true;
      this.isDisabled = true;
      axios
          .get(resolveApiBase(apiVersion()) + "/sanctum/csrf-cookie")
          .then((response) => {
          this.form
            .post("/api/usuario/senha/esqueceu")
            .then((response) => {
              this.loading = false;
              this.isDisabled = false;
              new ReturnApi(response, this, false, null, null, false);
              alert(response.msg);
            })
            .catch((errors) => {
              alert(errors.message);
              new ReturnApi(errors, this, true, null, null, false);
              this.errors_array = "";
              this.errors_array = [];
              for (var property in errors) {
                if (errors.hasOwnProperty(property)) {
                  if (typeof errors[property] === "object") {
                    errors[property].forEach((obj) => {
                      this.errors_array.push({
                        erro: obj,
                      });
                    });
                  }
                }
              }
            });
        });
    },
  },
  computed: {},
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap");

.container {
  /* margin-top: 25vh; */
  margin-left: auto;
  margin-right: auto;
  padding: 60px;
  font-family: "Roboto", sans-serif;
  width: 600px;
}

.container img {
  height: 120px;
  width: 120px;
}
.login-container h4 {
  margin-top: 30px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  font-size: 40px;
  color: #404041;
}
.login-container span {
  font-weight: 500;
  font-size: 15px;
  color: #808080;
  text-align: end;
  cursor: pointer;
  font-size: 16px;
  margin-top: 10px;
}
.login-card {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.login-card label {
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  color: #404041;
}
.login-card input {
  border-radius: 18px;
  border: solid 1px #c5ced7;
  height: 30px;
  /* margin-bottom: 15px; */
  font-size: 15px;
  padding-left: 15px;
}
.login-card input:focus-visible {
  outline: none;
}
.login-card button {
  background: linear-gradient(90deg, #ff7810 0%, #ffc705 100%);
  border: none;
  border-radius: 18px;
  height: 30px;
  font-size: 20px;
  margin-top: 30px;
}
.bottom-info {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-info a {
  margin-left: auto;
  font-size: 5px;
}
.bottom-info a span {
  font-size: 13px;
}
.bottom-info input {
  margin-bottom: 0;
  margin-right: 10px;
}
footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: linear-gradient(90deg, #ff7810 0%, #ffc705 100%);
  height: 40px;
}
@media (max-width: 550px) {
  .container {
    width: 100%;
    padding: 10px 40px;
  }
  .login-container h4 {
    font-size: 25px;
  }
}
</style>


